define.alias("ember-math-helpers/helpers/log2", "calendar/helpers/log2");